module.exports = __webpack_public_path__ + "static/img/049 3.8b782489.jpg";